var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroImgKolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 53,
    viewBox: "0 0 59 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4716 35.6124C24.4716 36.0036 24.4887 36.3868 24.5145 36.77C20.707 37.5707 16.7284 37.2367 13.1326 35.8146C9.53681 34.3925 6.50286 31.9529 4.45326 28.8358C2.40366 25.7186 1.44043 22.0789 1.69769 18.4236C1.95495 14.7682 3.41991 11.2792 5.88855 8.44232C8.3572 5.60545 11.7067 3.56194 15.4705 2.59639C19.2343 1.63083 23.2252 1.79127 26.8873 3.05539C30.5495 4.3195 33.7006 6.62438 35.9019 9.64901C38.1032 12.6736 39.2451 16.2675 39.1686 19.9301C35.1066 20.4191 31.3737 22.2811 28.6685 25.1677C25.9633 28.0543 24.4712 31.7675 24.4716 35.6124Z",
    fill: "",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.153 35.6124C58.1527 39.7056 56.4618 43.6393 53.4358 46.5861C50.4099 49.5329 46.2848 51.2632 41.928 51.4131C37.5711 51.5631 33.3222 50.121 30.0746 47.39C26.827 44.6591 24.8339 40.8523 24.5144 36.77C28.6115 35.9069 32.2819 33.7787 34.9386 30.7258C37.5952 27.6728 39.0846 23.8716 39.1685 19.9301C41.5417 19.6436 43.9526 19.8353 46.2406 20.4924C48.5287 21.1496 50.6413 22.2569 52.4377 23.7409C54.234 25.2248 55.6729 27.0511 56.6584 29.0982C57.644 31.1452 58.1535 33.3659 58.153 35.6124Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImgKolo);
export default __webpack_public_path__ + "static/media/hero-img-kolo.ab606d91cf08b504bf4ca644fc9afe43.svg";
export { ForwardRef as ReactComponent };